<template>
  <v-dialog v-model="show" :max-width="400" persistent>
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center pt-0">
            <div class="logofont text-shadow">
              <span class="primary--text">Why</span>
              <span class="secondary--text">Buy</span>
            </div>
          </v-col>
          <v-col cols="12" class="text-center pt-0">
            <h3 class="font-weight-light">{{this.$store.state.website.trial_ended}}</h3>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="goSubscribe">Subscribe</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "TrialEnded",
  created() {
    this.$eventBus.$on(
      "trial-ended",
      function() {
        this.show = true;
      }.bind(this)
    );
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    goSubscribe() {
      this.show = false;
      this.$router.push("/subscription");
    }
  }
};
</script>
<style lang="scss" scoped>
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 48px;
  letter-spacing: -2px;
}
</style>